/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import ActiveStep from './ActiveStep/index'
import React from 'react'
import Steps from './Steps/index'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Properties/Content/Content/Content"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 marginTop={dtSpaceS}
 size="large"
 text="The following app preferences are stored for the clinic. These settings help customize your experience, streamline workflows, and ensure the app functions according to your clinic’s needs.  Changes to these settings may impact how certain features behave for all users within the clinic. Adjust the settings below as needed."
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Steps
  viewPath={`${viewPath}/Steps`}
/>
<ActiveStep
  viewPath={`${viewPath}/ActiveStep`}
/>
</div>
{children}
</React.Fragment>)
}